import React from 'react'
import SettingSeoForm from '../components/setting/SettingsUzantiEditForm'

const SettingsUzanti = () => {
    return (
        <>
            <SettingSeoForm />
        </>
    )
}

export default SettingsUzanti